var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1139_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9128 27.0731L22.5872 31.0001L21.2616 27.0731C20.6365 25.2164 19.1156 23.7605 17.1761 23.1621L13.0737 21.8932L17.1761 20.6242C19.1156 20.0258 20.6365 18.5699 21.2616 16.7133L22.5872 12.7863L23.9128 16.7133C24.5379 18.5699 26.0588 20.0258 27.9984 20.6242L32.1007 21.8932L27.9984 23.1621C26.0588 23.7605 24.5407 25.2164 23.9128 27.0731Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.813 16.6651L13.0735 18.8583L12.334 16.6651C12.0214 15.7381 11.2595 15.0088 10.2912 14.7096L8 13.999L10.2912 13.2911C11.2595 12.9919 12.0214 12.2626 12.334 11.3356L13.0735 9.14233L13.813 11.3356C14.1256 12.2626 14.8874 12.9919 15.8558 13.2911L18.147 13.999L15.8558 14.7069C14.8874 15.0088 14.1284 15.7354 13.813 16.6651Z",
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1139_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 30,
    fill: "white",
    transform: "translate(8 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveAi);
export default __webpack_public_path__ + "static/media/InactiveAi.8e6316d729a24deac188a3adcf78b869.svg";
export { ForwardRef as ReactComponent };